module.exports = __webpack_public_path__ + "media/Intro_video.e7230894.mp4";